module.exports = __webpack_public_path__ + "static/img/section11_content1_bg1.1ca100e3.png";